import _extends from "@babel/runtime/helpers/extends";
import * as DriverDOM from 'driver-dom';
export default _extends({}, DriverDOM, {
  createElement: function createElement(type, props, component) {
    return DriverDOM.createElement(type, props, component, true);
  },
  setStyle: function setStyle(node, style) {
    return DriverDOM.setStyle(node, style, true);
  }
});